import api from './api';

/**
 * Servicio de consultas de soporte (Partner Portal, lado consultor cd-2b).
 * Consume /v1/partners/consultas/* con el partnerToken.
 */

const consultasService = {
  async getConsultas(params = {}) {
    const response = await api.get('/partners/consultas', { params });
    return response.data;
  },
  async getConsulta(id) {
    const response = await api.get(`/partners/consultas/${id}`);
    return response.data;
  },
  async responder(id, content) {
    const response = await api.post(`/partners/consultas/${id}/comentarios`, { content });
    return response.data;
  },
  async cambiarEstado(id, estado) {
    const response = await api.patch(`/partners/consultas/${id}/estado`, { estado });
    return response.data;
  },
};

export default consultasService;
